import { useContext, useEffect } from 'react';
import AuthContext from '../components/shared/AuthContext';
import apiClient from '../components/shared/hooks/AuthService';

const HEARTBEAT_MS = 45_000;

/** Keeps last-seen fresh for admin online status while the user has the app open. */
export default function useUserPresence() {
  const { isAuthenticated, isLoading } = useContext(AuthContext);

  useEffect(() => {
    if (isLoading || !isAuthenticated) return undefined;

    const ping = async () => {
      try {
        await apiClient.post('/api/users/me/presence');
      } catch {
        /* session may have expired */
      }
    };

    const onVisible = () => {
      if (document.visibilityState === 'visible') ping();
    };

    ping();
    const intervalId = window.setInterval(ping, HEARTBEAT_MS);
    document.addEventListener('visibilitychange', onVisible);

    return () => {
      window.clearInterval(intervalId);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [isAuthenticated, isLoading]);
}
